const portals = {};

// jsonp请求，根据ugc拿到实际的预览地址
portals['getPreviewUrl'] = {
    uri: '',
    method: 'GET',
    adapter: 'jsonp',
    queries: null,
    data: null
}

export default portals;